import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=0008e987"
import script from "./GDPR.vue?vue&type=script&lang=js"
export * from "./GDPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports